import type { PaginationApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { SyntheticEvent } from 'react';

export enum OSApplicationDetailsTabs {
  OVERVIEW = 'OVERVIEW',
  VERSIONS = 'VERSIONS',
  ORGANIZATIONS = 'ORGANIZATIONS',
}

export interface OsVersionRow {
  readonly deviceFamilyVersion: string;
  readonly version: string;
}

export enum VersionStatus {
  PUBLISHED = 'published',
  DEPRECATED = 'deprecated',
}

export interface OsVersionList {
  readonly data: OsVersionRows[];
  readonly pagination: PaginationApi;
}

export interface OsVersionRows {
  readonly version: string;
  readonly creationDate: Date | string;
  readonly status: VersionStatus;
  readonly id: string;
}

export interface OrganizationsRows {
  readonly name: string;
  readonly image: string;
  readonly type: string;
  readonly parent: string;
  readonly assignmentDate: string;
  readonly id: string;
}

export interface OrganizationFields {
  readonly id: string;
  readonly name: string;
}

export interface PublishModalOutput {
  readonly organizations: OrganizationFields[];
  readonly fixedOrganizations: OrganizationFields[];
  readonly onDelete: (evt: { readonly index: number }) => void;
  readonly isError: boolean;
  readonly isModalOpen: boolean;
  readonly isLoading: boolean;
  readonly isValid: boolean;
  readonly selectedOrganizations: OrganizationFields[];
  readonly shouldDisableChip: (input: OrganizationFields) => boolean;
  readonly getOptionLabel: (id: OrganizationFields | string) => string;
  readonly isOptionEqualsToValue: (option: OrganizationFields, value: OrganizationFields) => boolean;
  readonly onChange: (_: SyntheticEvent, data: OrganizationFields[]) => void;
  readonly onModalOpen: () => void;
  readonly onModalClose: () => void;
  readonly onSubmission: () => Promise<void>;
  readonly getOptionDisabled: (option: OrganizationFields) => boolean;
}

export const osVersionPublicationStatus = {
  DEPRECATED: 'DEPRECATED',
  PUBLISHED: 'PUBLISHED',
} as const;

export type OsVersionPublicationStatus = (typeof osVersionPublicationStatus)[keyof typeof osVersionPublicationStatus];

export interface GetOsByIdPayload {
  readonly compatibleDeviceFamilyNames?: string[];
  readonly creationDate?: Date;
  readonly id?: string;
  readonly logo?: string;
  readonly longDescription?: string;
  readonly name?: string;
  readonly osVersionIds?: string[];
  readonly publishedVersionNumbers?: string[];
  readonly publisherId?: string;
  readonly shortDescription?: string;
  readonly status?: OsVersionPublicationStatus;
}

export interface ContentDetailsDTO {
  readonly title: string;
  readonly status: {
    readonly label: string;
    readonly type: string;
  };
  readonly shortDescription: string;
  readonly longDescription: string;
  readonly markdown: string;
  readonly deviceFamilies: string[];
  readonly creationDate: Date | string;
  readonly publicationDate: Date | string;
  readonly latestVersion: string;
  readonly OSVersion?: OSVersion;
  readonly getByIdPayload?: GetOsByIdPayload;
}

export interface OSVersion {
  readonly name: string;
  readonly version: string;
}
